import { $black } from './commonColors';

const primaryMain = '#71273D';
const primaryMainOpacity = 'rgba(113, 39, 61, 0.9)';
const secondaryMain = '#736b61';
const secondaryMainOpacity = 'rgba(115, 107, 97, 0.5)';
const secondaryLight = $black;
const tertiaryMain = '#736B61';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
